import type { IUploadLog, IUploadLogInput } from '~/client/graph'

/**
 * An upload log as the SaveUploadLog input, field by field rather than spread, so what
 * goes on the wire is stated in one place.
 *
 * `locationType` is not sent: the client stopped selecting it, and SaveUploadLog would
 * otherwise write back whatever a stale log carried. Logs locate by `locationIds`
 * (STX1-1355).
 */
export function toUploadLogInput(uploadLog: IUploadLog): IUploadLogInput {
  return {
    createdAt: uploadLog.createdAt,
    fileCategory: uploadLog.fileCategory,
    fileType: uploadLog.fileType,
    fileUrl: uploadLog.fileUrl,
    id: uploadLog.id,
    isHidden: uploadLog.isHidden,
    locationIds: uploadLog.locationIds,
    locationName: uploadLog.locationName,
    metadata: uploadLog.metadata?.map(
      pair => pair && { key: pair.key, value: pair.value },
    ),
    projectId: uploadLog.projectId,
    projectName: uploadLog.projectName,
    sourceEntityCode: uploadLog.sourceEntityCode,
    sourceEntityId: uploadLog.sourceEntityId,
    sourceEntityType: uploadLog.sourceEntityType,
    sourceEntityTypeName: uploadLog.sourceEntityTypeName,
    updatedAt: uploadLog.updatedAt,
    userCompanyId: uploadLog.userCompanyId,
    userCompanyName: uploadLog.userCompanyName,
    userId: uploadLog.userId,
    userName: uploadLog.userName,
    version: uploadLog.version,
    workflowCategory: uploadLog.workflowCategory,
    workflowType: uploadLog.workflowType,
  }
}
